import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import Button from '../Button';
import GenerateWindow from './GenerateWindow';
import ArrowIcon from '../../../../assets/icon-arrow-forward-brown-filled.svg';

import styles from '../../../styles/views/components/AIChatbot/AIChatbot.module.scss';

const AIChatbot = ({
  currentUser,
  files,
  type,
  chapterData,
  nextChapterData,
  prompts,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [isGenerateWindowShown, setIsGenerateWindowShown] = useState(false);

  const toggleExpand = useCallback(() => setIsExpanded((prev) => !prev), []);
  const toggleGenerateWindow = useCallback(() => setIsGenerateWindowShown((prev) => !prev), []);

  if (isGenerateWindowShown) {
    return (
      <GenerateWindow
        currentUser={currentUser}
        generationType={type}
        files={files}
        onHide={toggleGenerateWindow}
        chapterData={chapterData}
        nextChapterData={nextChapterData}
        prompts={prompts}
      />
    );
  }

  return !isExpanded ? (
    <div className={styles.collapsedContainer}>
      <div className={styles.infoWrapper}>
        <div onClick={toggleExpand} className={styles.expandButton}>
          <ArrowIcon />
        </div>
        <p className={styles.collapsedTitle}>
          {t('components.genny', { ns: i18next.Namespace.COMMON })}
        </p>
      </div>
    </div>
  ) : (
    <div className={styles.container}>
      <div className={styles.infoWrapper}>
        <div onClick={toggleExpand} className={styles.hideButton}><ArrowIcon /></div>
        <p className={styles.title}>{t('components.genny', { ns: i18next.Namespace.COMMON })}</p>
        <p className={styles.infoText}>{t('components.aiWriter', { ns: i18next.Namespace.COMMON })}</p>
      </div>
      <Button
        color="gold"
        variant="primary"
        value={t('components.generate', { ns: i18next.Namespace.COMMON })}
        name="generate"
        isDisabled={isEmpty(files)}
        tooltip={isEmpty(files) ? t('components.uploadTranscripts', { ns: i18next.Namespace.COMMON }) : ''}
        wrapperExtraStyles={{ display: 'flex', flex: 1 }}
        extraStyles={{ flex: 1 }}
        onClick={toggleGenerateWindow}
      />
    </div>
  );
};

AIChatbot.propTypes = {
  prompts: PropTypes.array.isRequired,
  chapterData: PropTypes.object,
  nextChapterData: PropTypes.object,
  currentUser: PropTypes.object,
  type: PropTypes.string,
  files: PropTypes.array,
};

AIChatbot.defaultProps = {
  chapterData: {},
  nextChapterData: {},
  currentUser: {},
  type: '',
  files: [],
};

export default AIChatbot;
